<template>
  <div class="modal fade"
       :data-backdrop="backdrop"
       :data-keyboard="keyboard"
       aria-hidden="true"
       role="dialog"
       tabindex="-1"
       :id="id">
    <div class="modal-dialog modal-dialog-centered modal-dialog-centered-custom"
         :class="{'modal-dialog-scrollable': scrollable, 'modal-lg': large }"
         role="document">
      <div class="modal-content">
        <div class="modal-header shadow-none border-bottom">
          <h6 class="modal-title m-0 h6">{{ title }}</h6>
        </div>
        <div class="modal-body overflow-x-hidden py-3" v-html="content">
          <slot></slot>
        </div>
        <div class="modal-footer px-2 shadow-none">
          <button class="btn"
                  :class="{ 'bg-danger text-white': okButtonType === 'danger', 'btn-primary': okButtonType !== 'danger' }"
                  type="button"
                  @click="confirmAction"
                  :disabled="sending"
                  v-if="showOkButton">
            <span class="spinner-border text-white spinner-border-sm" role="status" v-if="sending">
              <span class="sr-only">Guardando...</span>
            </span>
            {{ okButtonText }}
          </button>
          <button class="btn btn-light ml-2"
                  data-dismiss="modal"
                  type="button"
                  :disabled="sending"
                  v-if="showCancelButton"
                  @click="$emit('cancel-button-pressed')">
            {{ cancelButtonText }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

  export default {
    name: 'OkCancelDialog',
    props: {
      id: {
        required: true,
        type: String,
        default: 'ok-cancel-modal',
      },
      title: {
        required: true,
        type: String,
      },
      content: {
        required: false,
        type: String,
      },
      okButtonText: {
        type: String,
        default: 'Aceptar',
      },
      okButtonType: {
        type: String,
      },
      cancelButtonText: {
        type: String,
        default: 'Cancelar',
      },
      backdrop: {
        type: String,
        default: 'static',
      },
      keyboard: {
        type: String,
        default: 'false',
      },
      okCallback: {
        type: Function,
        default: null,
      },
      showOkButton: {
        type: Boolean,
        default: true,
      },
      showCancelButton: {
        type: Boolean,
        default: true,
      },
      scrollable: {
        type: Boolean,
        default: false,
      },
      large: {
        type: Boolean,
        default: false,
      },
      data: null,
    },
    data() {
      return {
        sending: false,
      }
    },
    methods: {
      async confirmAction() {
        this.sending = true

        if(this.okCallback) {
          if(this.data) {
            await this.okCallback({
              data: JSON.parse(this.data)
            })
          }
          else {
            await this.okCallback()
          }

          this.sending = false
          $(this.$el).modal('hide')
        }

        this.$emit('ok-button-pressed')
      },
      close() {
        $(this.$el).modal('hide')
      },
    },
  }
</script>
